import { Component, h, Prop } from "@stencil/core"
import { InfoMessageModel } from "./InfoMessageModel"
import circleExclamationMarkIcon from "./img/circleExclamationMarkIcon.svg"
import triangleExclamationMarkIcon from "./img/triangleExclamationMarkIcon.svg"

/**
 * The component containing a place to display alerts and errors.
 */
@Component({
  tag: "info-message",
  styleUrl: "InfoMessage.scss",
})
export class InfoMessage {
  /**
   * The content of the message.
   */
  @Prop() infoMessage: InfoMessageModel

  render() {
    if (
      !this.infoMessage ||
      !this.infoMessage.infoType ||
      !this.infoMessage.infoMessage ||
      (this.infoMessage.infoType !== "ERROR" && this.infoMessage.infoType !== "ALERT")
    ) {
      return <div class="infoMessage">infoMessage prop error</div>
    }

    return (
      <div class={`infoMessage ${this.infoMessage.infoType === "ERROR" ? "error" : "alert"}`}>
        <div class="infoMessageContent">
          {this.infoMessage.infoType === "ERROR" ? (
            <img class="infoIcon" src={circleExclamationMarkIcon} alt="Exclamation mark icon" />
          ) : (
            <img class="infoIcon" src={triangleExclamationMarkIcon} alt="Exclamation mark icon" />
          )}

          <span class="infoMessageText">{this.infoMessage.infoMessage}</span>
          {this.infoMessage.clickableMessage && (
            <span class="infoMessageText clickable" onClick={this.infoMessage.onClick}>
              {this.infoMessage.clickableMessage}
            </span>
          )}
        </div>
      </div>
    )
  }
}
